// src/components/HeroSection.jsx
"use client";
import Image from "next/image";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useEffect, useRef } from "react";

export default function HeroSection() {
  // Function to scroll to mentorship section
  const scrollToMentorship = () => {
    const mentorshipSection = document.getElementById("mentorship");
    if (mentorshipSection) {
      mentorshipSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="w-full bg-white py-10 md:py-16 mt-20">
      <div className="w-[90%] md:w-[80%] mx-auto relative rounded-3xl overflow-hidden bg-[#012726]">
        <div className="relative">
          {/* Background grid image only */}
          <div className="absolute inset-0 z-0">
            <Image
              className="object-cover w-full h-full"
              src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/GS-Grid.png"
              alt="grid"
              width={1200}
              height={800}
              priority
            />
          </div>
             <div className="absolute inset-0 z-0">
            <Image
              className="object-cover w-full h-full opacity-15"
              src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/herotext.webp"
              alt="grid"
              width={1200}
              height={800}
              priority
            />
          </div>
          
          <div className="flex flex-col md:flex-row justify-between p-8 md:px-16 relative z-10">
            {/* Left Content */}
            <div className="w-full md:w-1/2 mb-10 md:mb-0 flex items-start justify-center flex-col">
              <h1 className="text-3xl md:text-[48px] font-medium text-[#F0E8D6] leading-tight mb-4">
                Become Top 1% in the AI-First World
              </h1>
              <p className="text-[#F0E8D6] text-sm sm:text-base font-normal opacity-90 mb-8 max-w-xl">
                Whether it is Product, Growth, Design, Business, Tech or Data, GrowthSchool is the place to learn from top experts in the field to become the Top 1%
              </p>
              <button 
                onClick={scrollToMentorship}
                className="bg-[#33c375] shadow-[inset_0_0_0_2px_rgba(0,39,38,0.3)] cursor-pointer hover:bg-[#6AD384] text-[#012726] font-medium px-6 py-3 rounded-xl stroke-2 flex items-center transition-all"
              >
                Explore Programs
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="10" 
                  height="13" 
                  viewBox="0 0 12 13" 
                  fill="none"
                  className="ml-2"
                >
                  <path
                    d="M1 7.11108L6 12L11 7.11108"
                    stroke="#002726"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1 1L6 5.88889L11 1"
                    stroke="#002726"
                    strokeOpacity="0.5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Right Content - Lottie Animation */}
            <div className="md:flex items-end justify-end w-full md:w-1/2 relative hidden">
              <DotLottieReact
                src="/images/bg.lottie"
                loop
                autoplay
                style={{
                  width: "348px",
                  height: "380px",
                  maskImage:
                    "linear-gradient(var(--mask-direction, to bottom), hsla(0, 0%, 0%, 0), hsl(0, 0%, 0%) 40%, hsl(0, 0%, 0%) 60%, hsla(0, 0%, 0%, 0))",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}